// Footer.js
import React from "react";
import "./Footer.css";
// import logo from ""; // ← إذا لوقو عندك بمجلد images

export default function Footer() {
  return (
    <footer className="mega-footer" dir="rtl">

      {/* القسم الأول – اللوقو + وصف مختصر */}
      <div className="footer-brand">
        <img src="/images/logo4.png" alt="Logo" className="footer-logo" />
        <p className="footer-description">
          الفطيرة الدمشقية — نخلط الأصالة السورية مع الجودة السعودية  
          لنقدم لكم أفضل أنواع الفطائر الطازجة يوميًا.
        </p>
      </div>

      {/* القسم الثاني – الفروع */}
      <div className="footer-section">
        <h3>📍 فروعنا</h3>
        <ul>
          <li>إشبيليا: 0500332322</li>
          <li>الازدهار: 0555826653</li>
          <li>المحمدية: 0539798890</li>
          <li>حطين: 0573625324</li>
          <li>الشهداء: 0550850028</li>
        </ul>
      </div>

      {/* القسم الثالث – معلومات الغذاء */}
      <div className="footer-section">
        <h3>🔥 السعرات الحرارية</h3>
        <p>يتم حساب السعرات لكل منتج بدقة ويمكن الاطلاع عليها في صفحة المنتج.</p>

        <h3>🥩 مصادر اللحوم والدواجن</h3>
        <p>اللحوم: بلدي طازج</p>
        <p>الدجاج: برازيلي مستورد</p>
        <p>جميع المستوردات معتمدة من هيئة الغذاء والدواء السعودية (SFDA).</p>

        <h3>💪 الاحتياج اليومي</h3>
        <p>الشخص البالغ: 2000 سعرة يوميًا</p>
        <p>الأطفال: 1400–1800 سعرة</p>
      </div>

      {/* القسم الرابع – العجين + QR */}
      <div className="footer-section">
        <h3>🍞 خيارات العجين</h3>
        <ul>
          <li>عجينة عادية</li>
          <li>عجينة بر</li>
        </ul>

        <h3>📱 تطبيق الفطيرة الدمشقية</h3>
        <img src="/images/qrcode.png" className="qr-code" alt="QR Code" />
      </div>

    </footer>
  );
}
